import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <main className="not-found-page">
      <div className="container not-found-inner">
        <div className="eyebrow"><span className="eyebrow-dot" /> 404 · Page not found</div>
        <h1>This page has moved <span>or never existed.</span></h1>
        <p>The link may be out of date. Try one of these instead.</p>
        <div className="not-found-links">
          <Link to="/" className="btn hero-primary">Back to home <span aria-hidden="true">→</span></Link>
          <Link to="/use-cases" className="hero-secondary">Browse use cases <span aria-hidden="true">→</span></Link>
        </div>
      </div>
    </main>
  );
}

export default NotFound;
